import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Field } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Heading from '../../heading/Heading';
import LocationInfo from '../../location/Location';
import ChangeLocation from '../../location/ChangeLocation';
import { Collapse } from 'react-bootstrap'; // Global Elements

import { FormSelect } from '../elements';
export default (function (props) {
  var store = props.store,
      location = props.location,
      results = props.results,
      changeHandler = props.changeHandler;

  var changeLocationHandler = function changeLocationHandler() {
    setOpen(!open);
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "Where was the Cracker Barrel?"
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: !open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-location"
  }, /*#__PURE__*/React.createElement(LocationInfo, {
    store: store,
    location: location,
    changeLocationHandler: changeLocationHandler
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "cb-collapse-locations"
  }, /*#__PURE__*/React.createElement(ChangeLocation, {
    store: store,
    location: location,
    results: results,
    showCurrent: false,
    setStoreHandler: changeLocationHandler
  }))))));
});